import React from "react"
import ReactDOM from "react-dom/client"
import './polyfills'
import '@ant-design/v5-patch-for-react-19'


import App from "./App"

// ----------------------------------------------------------------------------

ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
)
